import React, { useState } from 'react';
import { useQuery } from '@tanstack/react-query';
import { Link, useNavigate } from 'react-router-dom';
import * as teamService from '../services/teamService';

export const Teams: React.FC = () => {
  const navigate = useNavigate();
  const [searchQuery, setSearchQuery] = useState('');
  
  const { data: teams, isLoading, error } = useQuery(
    ['teams', searchQuery],
    () => teamService.getTeams(searchQuery || undefined)
  );
  
  return (
    <div>
      <div className="flex justify-between items-center mb-6">
        <h1 className="text-3xl font-bold">Teams</h1>
        <div className="flex space-x-3">
          <Link to="/teams/compare" className="bg-blue-100 text-blue-700 px-4 py-2 rounded hover:bg-blue-200">
            Compare Teams
          </Link>
          <Link to="/teams/new" className="bg-blue-600 text-white px-4 py-2 rounded hover:bg-blue-700">
            Create New Team
          </Link>
        </div>
      </div>
      
      <div className="mb-6">
        <input
          type="text"
          placeholder="Search teams..."
          className="w-full px-4 py-2 border border-gray-300 rounded-md"
          value={searchQuery}
          onChange={(e) => setSearchQuery(e.target.value)}
        />
      </div>
      
      {isLoading ? (
        <div className="text-center py-10">Loading teams...</div>
      ) : error ? (
        <div className="text-center py-10 text-red-600">Error loading teams</div>
      ) : teams && teams.length > 0 ? (
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {teams.map(team => (
            <div 
              key={team.id}
              className="bg-white rounded-lg shadow-md p-6 hover:shadow-lg transition-shadow cursor-pointer"
              onClick={() => navigate(`/teams/${team.id}`)}
            >
              <h2 className="text-xl font-semibold mb-2">{team.name}</h2>
              <p className="text-gray-600 mb-4">{team.description || team.goal}</p>
              
              <div className="flex justify-between items-center">
                <div className="text-sm text-gray-500">
                  Roster: {team.roster_id}
                </div>
                
                <div className="flex flex-wrap gap-1">
                  {team.tags.slice(0, 3).map(tag => (
                    <span 
                      key={tag}
                      className="px-2 py-0.5 bg-gray-100 text-gray-700 text-xs rounded-full"
                    >
                      {tag}
                    </span>
                  ))}
                  {team.tags.length > 3 && (
                    <span className="px-2 py-0.5 bg-gray-100 text-gray-700 text-xs rounded-full">
                      +{team.tags.length - 3}
                    </span>
                  )}
                </div>
              </div>
            </div>
          ))}
        </div>
      ) : (
        <div className="text-center py-10 bg-gray-50 rounded-lg">
          <p className="text-gray-500 mb-4">No teams found</p>
          <button
            onClick={() => navigate('/teams/new')}
            className="px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-700"
          >
            Create New Team
          </button>
        </div>
      )}
    </div>
  );
};
